import { render, staticRenderFns } from "./LoaderApp.vue?vue&type=template&id=3ffa3dd7&scoped=true"
import script from "./LoaderApp.vue?vue&type=script&lang=js"
export * from "./LoaderApp.vue?vue&type=script&lang=js"
import style0 from "./LoaderApp.vue?vue&type=style&index=0&id=3ffa3dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa3dd7",
  null
  
)

export default component.exports